// © Microsoft Corporation. All rights reserved.

export const elementKey = {
    addTopSiteButton: "addTopSiteButton",
    backgroundOuterHolder: "backgroundOuterHolder",
    backgroundInnerHolder: "backgroundInnerHolder",
    cardAction: "cardAction",
    feedToggle: "feedToggle",
    headerSpaceHolder: "headerSpaceHolder",
    marketSelector: "marketSelector",
    navBar: "navBar",
    recommendedSites: "recommendedSites",
    rewardsIcon: "rewardsIcon",
    rightRailSectionKey: "rightRailSectionKey",
    singleColumnFeedRoot: "singleColumnFeedRoot",
    searchBox: "search-box-edgenext",
    searchBoxVoiceButton: "searchBoxVoiceButton",
    searchHistory: "searchHistoryEdgeNext",
    settingsButton: "SettingsButton",
    topSites: "topSites",
    topSitesFirstLink: "quicklinksFirstLink",
    topSitePlaceHolder: "topSitePlaceHolder",
    waffle: "waffle"
};